import {
  ResourceQueryApiQueryInventoryResourcesRequest,
  ResourceQueryResponse,
} from '@ariksa/inventory-core/api';

import { InventoryService } from 'api/services';

export interface InventoryResourceQueryRequest {
  environment_id?: string;
  account_id?: string[];
  provider?: string[];
  category?: string[];
  resource_type?: string[];
  native_type?: string[];
  service?: string[];
  region?: string[];
  vpcs?: string[];
  search_term?: string;
  page?: number;
  size?: number;
  cursor?: string;
}

export interface InventoryResourceQueryResponse {
  items: any[];
  total: number;
  page: number;
  size: number;
  next_cursor?: string;
  manifest_token: string;
}

export async function getInventoryResourceQuery(
  request: InventoryResourceQueryRequest,
): Promise<InventoryResourceQueryResponse> {
  const response = await InventoryService.ResourceQuery.queryInventoryResources(
    {
      resourceQueryRequest: request as ResourceQueryApiQueryInventoryResourcesRequest['resourceQueryRequest'],
    },
  );
  const data = response.data as ResourceQueryResponse;
  return {
    ...data,
    next_cursor: data.next_cursor ?? undefined,
  };
}
